import axios from 'axios'

export const call = ({domainEndpoint, url, token, version, method, lang, authorization, ...args}) => new Promise((resolve, reject) => {
  try {
    var requestData = {
      requestHeader: {
        'acceptLanguage': navigator.language,
        'externalReferer': document.referrer,
        'lang': lang,
        'referer': document.location.href,
        'userAgent': navigator.userAgent,
        'product': navigator.product,
        'platform': navigator.platform,
        'vendor': navigator.vendor,
        'token': token,
        'version': version
      }
    }
    requestData.requestContent = args.data

    var endpointUrl = ''
    if (domainEndpoint) {
      endpointUrl += domainEndpoint
    }
    endpointUrl += url

    var requestParams = {
      method: method,
      url: endpointUrl,
      data: requestData,
      headers: {
        authorization: authorization
      }
    }

    if (args.blobMode) {
      requestParams.responseType = 'blob'
    }

    resolve(
      axios(requestParams)
        .then(function (response) {
          if (args.blobMode) {
            return response
          } else {
            return response.data
          }
        })
    )
  } catch (err) {
    reject(new Error(err))
  }
})
